export default "__VITE_ASSET__Yybgud8Z__"